import script from "./DashboardCouvert.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardCouvert.vue?vue&type=script&setup=true&lang=js"

import "./DashboardCouvert.vue?vue&type=style&index=0&id=5a100774&lang=css"

const __exports__ = script;

export default __exports__